<template>
  <div
    :style="{ width: show ? '400px' : '0' }"
    class="container-map-tab-stm zones-areas bg-white"
  >
    <b-tabs fill @input="$emit('on-tab-changed', $event)">
      <b-tab :title="$t('zones.working_areas')">
        <zone-country-areas
          @on-row-click="$emit('on-country-zone-row-click', $event)"
        ></zone-country-areas>
      </b-tab>
      <b-tab
        :disabled="!activeCountryZone"
        :title="$t('zones.zones_fixed_price')"
      >
        <zone-in-country-areas
          @on-row-click="$emit('on-in-country-zone-row-click', $event)"
        ></zone-in-country-areas>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ZoneCountryAreas from './zone-country-areas'
import ZoneInCountryAreas from './zone-in-country-areas'

export default {
  name: 'ZoneManagerPanel',

  components: {
    ZoneInCountryAreas,
    ZoneCountryAreas,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  computed: mapGetters('zones', ['activeCountryZone']),
}
</script>
<style lang="scss">
.zones-areas {
  table {
    th {
      min-width: 90px !important;
    }
    th,
    td {
      padding: 0.5rem;
    }
  }
}
</style>
